// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"8f0dd0af","268":"ae93a52a","312":"1795bf43","508":"7dd771b7","638":"67f8dc2e","800":"04146e0f"}[chunkId] + ".chunk.js";
};